<div class="p-4 queue-table">
  <div class="mb-2">
    <app-queue-action-buttons
      (resetData)="reloadQueue()"
      (clear)="setDefaultTableState()"
    ></app-queue-action-buttons>
  </div>

  <p-table
    styleClass="has-border  frozen-columns-table"
    aria-label="HH Queue Table"
    scrollHeight="flex"
    data-test-id="hh-queue-table"
    resetTablePageOnSort
    [stateKey]="tableSettings.stateKey"
    [dataKey]="tableSettings.dataKey"
    [rows]="tableSettings.rowsPerPage"
    [totalRecords]="totalRecords"
    [paginator]="true"
    [scrollable]="true"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    [columns]="columnConfig"
    [filterDelay]="1000"
    [loading]="isLoading"
    [value]="queueData$ | async"
    [(first)]="first"
    [(selection)]="selectedRows"
    (onLazyLoad)="fetchTableData($event)"
    (onHeaderCheckboxToggle)="headerCheckboxToggle($event)"
    (onFilter)="table.saveState()"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 42px;"
            alignFrozen="left"
            pFrozenColumn
            [frozen]="true"
            [class]="{'frozen-border': true}"
        ></th>
        @for (column of columnConfig; track column) {
          <th
            alignFrozen="left"
            pFrozenColumn
            [frozen]="column.field === 'userName' ||  column.field === 'alerts'"
            [class]="{'frozen-border': column.field === 'userName' ||  column.field === 'alerts'}"
            [style]="column.styles"
            [pSortableColumn]="column.sortByKey || column.field"
            [pSortableColumnDisabled]="!column.isSortable"
          >
            <div class="flex items-center gap-2">
              {{ column.header }}
              @if (column.isSortable) {
                <p-sortIcon
                  data-test-id="sort-icon"
                  [field]="column.sortByKey || column.field"
                >
                </p-sortIcon>
              }
            </div>
          </th>
        }
      </tr>
      <tr class="header-filter">
        <th class="justify-center"
            alignFrozen="left"
            pFrozenColumn
            [frozen]="true"
            [class]="{'frozen-border': true}"
        >
          <p-tableHeaderCheckbox #headerCheckBox data-test-id="header-checkbox"></p-tableHeaderCheckbox>
        </th>
        @for (column of columnConfig; track column) {
          <th
            alignFrozen="left"
            pFrozenColumn
            [frozen]="column.field === 'userName' || column.field === 'alerts'"
            [class]="{'frozen-border': column.field === 'userName' ||  column.field === 'alerts'}"
          >
            <ng-container
              *ngTemplateOutlet="
              filterTemplates[column.filterTemplate];
              context: { column: column }
            "
            ></ng-container>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template let-queueItem pTemplate="body">
      <tr
        [pSelectableRow]="queueItem">
        <td
          alignFrozen="left"
          pFrozenColumn
          [frozen]="true"
          [class]="{'frozen-border': true}"
        >
          <p-tableCheckbox data-test-id="table-checkbox" [value]="queueItem"></p-tableCheckbox>
        </td>
        @for (column of columnConfig; track column) {
          @if (column.field === 'userName' || column.field === 'alerts') {
            <td
              pFrozenColumn
              [attr.alignFrozen]="'left'"
              [frozen]="true"
              [class]="{ 'frozen-border': true }"
            >
              <ng-container
                *ngTemplateOutlet="cellContent; context: { column: column, queueItem: queueItem }"></ng-container>
            </td>
          } @else {
            <td>
              <ng-container
                *ngTemplateOutlet="cellContent; context: { column: column, queueItem: queueItem }"></ng-container>
            </td>
          }
        }
      </tr>
    </ng-template>

    <ng-template #cellContent let-column="column" let-queueItem="queueItem">
      @switch (column.field) {
        @case ('alerts') {
          <div class="flex items-center gap-2" aria-label="Alerts for this case">
            @if (queueItem.isEscalatedCase) {
              <i class="pi pi-exclamation-circle font-normal highlitedRed">
              </i>
              <span>Escalated Case</span>
            }
            @if (queueItem.highlightedInRed || queueItem.adCompleteOverdue) {
              <i class="pi pi-clock  font-normal  icon-color"></i>
              <span>Time Overdue</span>
            }
            @if (queueItem.highlightedInYellow) {
              <i class="pi pi-bell font-normal icon-color">
              </i>
              <span>Approaching Deadline</span>
            }
            @if (queueItem.highlightedInBlue) {
              <i class="pi pi-info-circle font-normal icon-color">
              </i>
              <span>General Information</span>
            }
          </div>
        }
        @case ('userName') {
          <div class="flex justify-between items-center">
            <span tooltipPosition="bottom" [pTooltip]="queueItem[column.field]">
              {{ queueItem.userName }}
            </span>
            @if (queueItem?.secondLevelReview) {
              <span tooltipPosition="bottom" [pTooltip]="'Routed to ' + queueItem.secondLevelReview">
                <i class="pi pi-info-circle font-normal icon-color" data-test-id="exclamation-triangle-icon"></i>
              </span>
            }
          </div>
        }
        @case ('urgency') {
          <div class="flex justify-between items-center">
            {{ queueItem.urgency }}
            @if (queueItem.hasNewClinicalResponse) {
              <span pTooltip="New Clinical Response" tooltipPosition="bottom">
                <i class="pi pi-info-circle font-normal icon-color" data-test-id="info-icon"></i>
              </span>
            }
          </div>
        }
        @case ('anticipatedManualDecisionDate') {
          @if (queueItem.timeRemaining) {
            <queue-countdown
              tooltipPosition="bottom"
              [desicionDate]="queueItem.anticipatedManualDecisionDate"
              [showTimeOutWarning]="queueItem.showTimeOutWarning"
              [pTooltip]="queueItem[column.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'"
            />
          }
          @if (queueItem.showTimeOutWarning) {
            <queue-countup
              [clinicalReviewAdjudicationDate]="queueItem.clinicalReviewAdjudicationDate"
              [elapsedBusinessTime]="queueItem.elapsedBusinessTime"
              [nextNonBusinessDate]="queueItem.nextNonBusinessDate"
              [isBusinessDayNow]="queueItem.isBusinessDayNow"
              [anticipatedManualDecisionDate]="queueItem.anticipatedManualDecisionDate"
              [urgency]="queueItem.urgency"
              [timeTakenForReviewAdjudication]="queueItem.timeTakenForReviewAdjudication">
            </queue-countup>
          }
        }
        @case ('requestReceivedDate') {
          <div class="flex justify-between items-center">
            <span tooltipPosition="bottom" [pTooltip]="queueItem[column.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'">
              {{ queueItem.requestReceivedDate | timeSpent: '[d] day(s) + [h]h:[m]m' }}
            </span>
          </div>
        }
        @case ('memberName') {
          <div class="flex justify-between items-center">
            <button
              pButton
              class="p-button-link text-left px-0 mx-2"
              tooltipStyleClass="tooltip-xxl-size"
              tooltipPosition="bottom"
              data-test-id="navigate-to-member-button"
              pTooltip="{{ queueItem[column.field] }} | {{queueItem['memberSubscriberNumber'] }}"
              (click)="navigateToMemberPage(queueItem)"
            >
              {{ queueItem[column.field] }}
            </button>
            @if (queueItem.shouldShowWccWarning) {
              <span pTooltip="WCC Admission" tooltipPosition="bottom">
                <i class="pi pi-info-circle font-normal icon-color" data-test-id="clock-icon"></i>
              </span>
            }
          </div>
        }
        @case ('authorizationNumber') {
          <div class="w-full">
            <button
              pButton
              class="p-button-link text-left px-0"
              data-test-id="navigate-to-auth-button"
              [label]="queueItem[column.field]"
              (click)="navigateToAuthorization(queueItem)"
            ></button>
          </div>
        }
        <!-- 204807: onceSkillCode is null, then expect to display ZZ from hcpcCode field by current logic -->
        @case ('skillCode') {
          <div
            class="flex justify-between items-center">
            <button
              pButton
              class="p-button-link text-left px-0 mx-2"
              tooltipStyleClass="tooltip-xxl-size"
              tooltipPosition="bottom"
              data-test-id="navigate-to-sl-button"
              [pTooltip]="queueItem[column.field] ? queueItem[column.field] : queueItem['hcpcCode']"
              [label]="queueItem[column.field] ? queueItem[column.field] : queueItem['hcpcCode']"
              (click)="navigateToServiceLine(queueItem)"
            ></button>
          </div>
        }
        @case ('hcpcCode') {
          <div class="flex justify-between items-center">
            <button
              pButton
              class="p-button-link text-left px-0 mx-2"
              tooltipStyleClass="tooltip-xxl-size"
              tooltipPosition="bottom"
              data-test-id="navigate-to-sl-button"
              [pTooltip]="queueItem[column.field]"
              [label]="queueItem[column.field]"
              (click)="navigateToServiceLine(queueItem)"
            ></button>
          </div>
        }
        @case ('providerNpi') {
          <span tooltipPosition="bottom" [pTooltip]="queueItem['providerName']">
            {{ queueItem.providerNpi }}
          </span>
        }
        @case ('serviceLineStatusReason') {
          <span tooltipPosition="bottom" [escape]="false" [pTooltip]="queueItem.outreachReasonsTooltip">
            {{ queueItem.serviceLineStatusReason }}
          </span>
        }
        @case ('additionalInformationReceived') {
          <div class="flex justify-center w-full">
            <p-checkbox
              data-test-id="additional-info-checkbox"
              [binary]="true"
              [disabled]="true"
              [ngModel]="queueItem[column.field]"
            ></p-checkbox>
          </div>
        }
        @case ('routedDate') {
          <span tooltipPosition="bottom" [pTooltip]="queueItem[column.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'">
            {{ queueItem.routedDate | timeSpent: '[d] day(s) + [h]h:[m]m' }}
          </span>
        }
        @case ('isQualityCheckComplete') {
          <div class="flex justify-center w-full">
            <p-checkbox
              data-test-id="quality-check-checkbox"
              [binary]="true"
              [disabled]="true"
              [ngModel]="queueItem[column.field]"
            ></p-checkbox>
          </div>
        }
        @default {
          <div
            class="truncate"
            tooltipPosition="bottom"
            [pTooltip]="queueItem[column.field]"
          >
            {{ queueItem[column.field] }}
          </div>
        }
      }
    </ng-template>
    <ng-template let-columns pTemplate="emptymessage">
      <tr>
        <td data-test-id="no-records-row" [attr.colspan]="columns.length + 1">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="mt-2">
    <div class="mb-2 font-semibold" data-test-id="selected-rows-label">
      {{ selectedRows.length | pluralize: 'queue' }} selected
    </div>
    <button
      *accessView="['HHServiceLineQueue.Route']"
      pButton
      label="Route to Queue"
      icon="pi pi-send"
      class="p-button mr-2"
      data-test-id="route-to-queue-button"
      [disabled]="routingDisabled"
      (click)="showRouteToQueueDialog()"
    ></button>
    <button
      *accessView="['HHServiceLineQueue.Route']"
      pButton
      label="Send to Resource Router"
      type="button"
      class="p-button"
      data-test-id="send-to-rr-button"
      [disabled]="routingDisabled"
      (click)="sendToResourceRouter()"
    ></button>
    <button
      *accessView="['HHServiceLineQueue.Delete']"
      pButton
      label="Remove from Queue"
      class="p-button ml-2"
      icon="pi pi-trash"
      data-test-id="remov-from-queue-button"
      [disabled]="routingDisabled"
      (click)="removeFromQueue()"
    ></button>
    <button
      pButton
      label="Do Next"
      icon="pi pi-arrow-right"
      class="p-button ml-2"
      data-test-id="do-next-button"
      [disabled]="routingDisabled"
      (click)="showDoNextDialog()"
    ></button>
  </div>
</div>

@if (isRoutingDialogVisible) {
  <app-route-queue-modal
    [currentUser]="currentUser"
    [users]="usersListForRouting"
    [isVisible]="isRoutingDialogVisible"
    [isLoading]="isLoadingManualRoute"
    (submitRoute)="sendToUser($event, selectedRows)"
    (closeDialog)="closeRouteDialog()"
  >
  </app-route-queue-modal>
}
<p-confirmDialog
  rejectLabel="Cancel"
  appendTo="body"
  rejectButtonStyleClass="p-button-info"
  data-test-id="confirm-dialog"
  [transitionOptions]="'0ms'"
  [style]="{ width: '424px' }"
></p-confirmDialog>

<p-toast position="center"></p-toast>

<ng-template #input let-columnConfig="column">
  <p-iconfield>
    <p-inputicon class="pi pi-search" />
    <input
      class="p-column-filter"
      pInputText
      type="text"
      placeholder="Search"
      data-test-id="input-filter"
      [value]="
        table.filters?.[columnConfig.multiFilterReadBy || columnConfig.field]
          ?.value
      "
      (input)="filterTable(
        $event.target.value.trim(),
        columnConfig.multiFilterProperties || columnConfig.field,
        'contains'
      )"
    />
  </p-iconfield>
</ng-template>

<ng-template #dropdown let-columnConfig="column">
  <p-select
    class="w-full"
    styleClass="w-full"
    appendTo="body"
    placeholder="Filter"
    [showClear]="true"
    [options]="filtersData?.[columnConfig?.field]"
    [ngModel]="table.filters?.[columnConfig?.field]?.value"
    (onChange)="filterTable($event.value, columnConfig?.field, 'in')"
  />
</ng-template>

<ng-template #multiselect let-columnConfig="column">
  <p-multiSelect
    styleClass="p-column-filter"
    panelStyleClass="queue-multiselect"
    placeholder="Filter"
    appendTo="body"
    data-test-id="multiselect-filter"
    filterPlaceHolder="Search"
    [ngModel]="table.filters?.[columnConfig?.filterByKey || columnConfig?.field]?.value"
    [options]="filtersData?.[columnConfig?.filterByKey || columnConfig?.field]"
    [filter]="columnConfig.filtering"
    [filterBy]="columnConfig.multiFilterReadBy || null"
    (onChange)="filterTable($event.value,columnConfig.filterByKey || columnConfig.field,'in')"
  >
  </p-multiSelect>
</ng-template>

